import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function ExpandMore(props:any) {
  return (
    <SvgIcon {...props}>
      <path d="M12 15.5l-7-7 1.41-1.41L12 12.67l5.59-5.58L19 8.5z" />
    </SvgIcon>
  )
}
